export const COUPON_TYPE_LABEL = {
    1: '商家券',
    2: '通用券',
};
export const COUPON_STATUS = {
    STATUS_NEW: 1,
    STATUS_RECEIVED: 2,
    STATUS_FAILED: 3,
    STATUS_USED: 4,
    STATUS_EXPIRED: 5,
    STATUS_LOCKED_NEW: 6,
    STATUS_RECEIVE_EXPIRED: 7,
};
export const COUPON_TYPE = {
    RED_BAG: 2, // 通用红包
    SHOP_COUPON: 1, // 商家券
};
export const COUPON_REMAIN_STATUS = {
    REMAIN_STATUS_DEFAULT: 0, // 默认填充值，没有任何意义
    REMAIN_STATUS_NEW: 1, // 存在未领取券
    REMAIN_STATUS_RECEIVED: 2, // 券已经被用户领取
    REMAIN_STATUS_NONE: 3, // 无任何券可以领取
};
